export default __webpack_public_path__ + "images/WX.04a83c8.png";